import type React from 'react';

import { Switch } from '@vlabs/uikit/components/controls/switch/Switch';
import type { SwitchProps } from '@vlabs/uikit/components/controls/switch/Switch';
import type { WithDataTestid } from '@vlabs/uikit/types';

import { useTableSettingsContext } from '@vlabs/monokit/entities/events/context/TableSettingsContext';

import { useToggleTopMatchTranslation } from './i18n';
import { buildTestid } from '../../../shared/lib/utils';

type ToggleTopMatchSwitchProps = WithDataTestid & SwitchProps;

const displayName = 'ToggleTopMatchSwitch';
const testid = buildTestid(displayName);

function ToggleTopMatchSwitch({
  'data-testid': dataTestId = undefined,
  ...props
}: ToggleTopMatchSwitchProps): React.JSX.Element {
  const { t } = useToggleTopMatchTranslation();
  const { settings, onChangeSettings } = useTableSettingsContext();
  return (
    <Switch
      {...props}
      label={t('label')}
      onChange={(isTopMatchVisible) => onChangeSettings({ isTopMatchVisible })}
      value={settings.isTopMatchVisible}
      {...testid(dataTestId)}
    />
  );
}

ToggleTopMatchSwitch.displayName = displayName;

export { ToggleTopMatchSwitch };
